import React from 'react'
import {Navigate} from 'react-router-dom'
import {useReduxAuth} from '../../../auth'
import {RoleGuardProps} from '../../../../entities/entities'

const RoutesRoleGuard: React.FC<RoleGuardProps> = ({allowedRoles, children}) => {
  const {currentUser} = useReduxAuth()

  // If not even logged in, send them to login
  if (!currentUser) {
    return <Navigate to='/login' replace />
  }

  // If their role_id is in the list, render; otherwise 403
  return allowedRoles.includes(currentUser?.role_id) ? (
    <>{children}</>
  ) : (
    <Navigate to='/unauthorized' replace />
  )
}

export default RoutesRoleGuard
